import LabelBackground from '@/components/LabelBackground/LabelBackground';
import useCalendar, {
	MonthlyCalendarEntry,
} from '@/hooks/calendar/useCalendar';
import useSpecies from '@/hooks/species/useSpecies';
import SingleCalendarSpecies from './SingleCalendarSpecies';
import {
	CalendarAttributes,
	SpeciesAttributes,
	StrapiEntry,
} from '@/lib/apiTypes';
import { useMemo } from 'react';

type CalendarEntryWithSpecies = {
	calendarEntry: StrapiEntry<CalendarAttributes>;
	species: StrapiEntry<SpeciesAttributes>;
};

const MonthOverview = ({ month }: { month: MonthlyCalendarEntry }) => {
	const { findSpeciesById } = useSpecies();
	const { speciesOfTheWeekDate } = useCalendar();

	const monthCalendarEntriesWithSpecies: CalendarEntryWithSpecies[] =
		useMemo(() => {
			return month.entries
				.map((entry) => ({
					calendarEntry: entry,
					species: findSpeciesById(
						entry.attributes.speciesEntry.data?.id
					),
				}))
				.filter(
					(entry) => entry.species !== undefined
				) as CalendarEntryWithSpecies[];
		}, [month.entries, findSpeciesById]);

	return (
		<section aria-label={month.displayName} className="overflow-x-clip">
			<div className="flex items-center justify-end p-4 font-brand text-3xl text-accentCompat">
				<h2 className="relative px-4 py-1.5">
					<LabelBackground className="text-accent" />
					<span className="relative">{month.displayName}</span>
				</h2>
			</div>
			<ul className="grid gap-2 sm:gap-3 lg:gap-4">
				{monthCalendarEntriesWithSpecies.map((item) => (
					<SingleCalendarSpecies
						key={item.calendarEntry.id}
						calendarEntry={item.calendarEntry}
						species={item.species}
						isSpeciesOfTheWeek={
							// Check day, month and full year
							speciesOfTheWeekDate?.getDate() ==
							new Date(
								item.calendarEntry.attributes.date
							).getDate() &&
							speciesOfTheWeekDate?.getMonth() ==
							new Date(
								item.calendarEntry.attributes.date
							).getMonth() &&
							speciesOfTheWeekDate?.getFullYear() ==
							new Date(
								item.calendarEntry.attributes.date
							).getFullYear()
						}
					/>
				))}
			</ul>
		</section>
	);
};

export default MonthOverview;
